/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Starter_Challenge_Complete_DescriptionInputs */

const en_starter_challenge_complete_description = /** @type {(inputs: Starter_Challenge_Complete_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You've completed your first challenges and leveled up your focus skills.

Ready for the next focus chapter?`)
};

const ar_starter_challenge_complete_description = /** @type {(inputs: Starter_Challenge_Complete_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لقد أنهيت تحدياتك الأولى وارتقيت بمهارات التركيز لديك.

هل أنت مستعد لفصل التركيز التالي؟`)
};

const de_starter_challenge_complete_description = /** @type {(inputs: Starter_Challenge_Complete_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast deine ersten Herausforderungen gemeistert und deine Fokus-Fähigkeiten verbessert.

Bereit für das nächste Fokus-Kapitel?`)
};

const es_starter_challenge_complete_description = /** @type {(inputs: Starter_Challenge_Complete_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Has completado tus primeros desafíos y mejorado tus habilidades de concentración.

¿Listo para el próximo capítulo de concentración?`)
};

const fr_starter_challenge_complete_description = /** @type {(inputs: Starter_Challenge_Complete_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous avez relevé vos premiers défis et amélioré vos compétences de concentration.

Prêt(e) pour le prochain chapitre de concentration ?`)
};

const it_starter_challenge_complete_description = /** @type {(inputs: Starter_Challenge_Complete_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai completato le tue prime sfide e migliorato le tue capacità di concentrazione.

Pronto per il prossimo capitolo di concentrazione?`)
};

const ja_starter_challenge_complete_description = /** @type {(inputs: Starter_Challenge_Complete_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最初のチャレンジをすべてクリアし、集中力がレベルアップしました。

次の集中の章へ進む準備はできましたか？`)
};

const ko_starter_challenge_complete_description = /** @type {(inputs: Starter_Challenge_Complete_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`첫 챌린지를 모두 완료하고 집중력이 레벨업되었어요.

다음 집중 챕터로 떠날 준비가 되셨나요?`)
};

const pt_br_starter_challenge_complete_description = /** @type {(inputs: Starter_Challenge_Complete_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você concluiu seus primeiros desafios e aprimorou suas habilidades de foco.

Pronto para o próximo capítulo de foco?`)
};

const ru_starter_challenge_complete_description = /** @type {(inputs: Starter_Challenge_Complete_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы выполнили свои первые задания и повысили свои навыки концентрации.

Готовы к следующей главе концентрации?`)
};

const th_starter_challenge_complete_description = /** @type {(inputs: Starter_Challenge_Complete_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณทำภารกิจแรกทั้งหมดสำเร็จและพัฒนาทักษะการโฟกัสขึ้นอีกขั้นแล้ว

พร้อมสำหรับบทใหม่ของการโฟกัสหรือยัง?`)
};

const tr_starter_challenge_complete_description = /** @type {(inputs: Starter_Challenge_Complete_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İlk görevlerini tamamladın ve odaklanma becerilerini geliştirdin.

Bir sonraki odak bölümüne hazır mısın?`)
};

const zh_cn_starter_challenge_complete_description = /** @type {(inputs: Starter_Challenge_Complete_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你已经完成新手任务，成功让专注力再升级！

准备好迈向下一个专注篇章了吗？`)
};

const zh_tw_starter_challenge_complete_description = /** @type {(inputs: Starter_Challenge_Complete_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你已經完成新手任務，成功讓專注力再升級！

準備好邁向下一個專注篇章了嗎？`)
};

/**
* | output |
* | --- |
* | "You've completed your first challenges and leveled up your focus skills. Ready for the next focus chapter?" |
*
* @param {Starter_Challenge_Complete_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const starter_challenge_complete_description = /** @type {((inputs?: Starter_Challenge_Complete_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Starter_Challenge_Complete_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_starter_challenge_complete_description(inputs)
	if (locale === "ar") return ar_starter_challenge_complete_description(inputs)
	if (locale === "de") return de_starter_challenge_complete_description(inputs)
	if (locale === "es") return es_starter_challenge_complete_description(inputs)
	if (locale === "fr") return fr_starter_challenge_complete_description(inputs)
	if (locale === "it") return it_starter_challenge_complete_description(inputs)
	if (locale === "ja") return ja_starter_challenge_complete_description(inputs)
	if (locale === "ko") return ko_starter_challenge_complete_description(inputs)
	if (locale === "pt_br") return pt_br_starter_challenge_complete_description(inputs)
	if (locale === "ru") return ru_starter_challenge_complete_description(inputs)
	if (locale === "th") return th_starter_challenge_complete_description(inputs)
	if (locale === "tr") return tr_starter_challenge_complete_description(inputs)
	if (locale === "zh_cn") return zh_cn_starter_challenge_complete_description(inputs)
	return zh_tw_starter_challenge_complete_description(inputs)
});